<template>
    <div class='base-info text-popper' v-textPopper :style="`width: ${width};font-size: ${fontSize}`">
        <span class="des">
            {{ des }}<slot name="des"/>：
        </span>
        <span>{{ result }}<slot/></span>
    </div>
</template>

<script>
export default {
    props: {
        des: {
            type: String,
            default: ''
        },
        result: {
            type: [String, Number],
            default: ''
        },
        width: {
            type: String,
            default: '180px'
        },
        fontSize: {
            type: String,
            default: '14px'
        }
    }
}
</script>

<style lang="scss" scoped>
.base-info {
    display: inline-block;
    color: #2a2a2a;

    .des {
        color: #666;
    }
}
</style>